import ExpandtoRightOutlined from '@icons/ExpandtoRightOutlined';
import { shareCampaign } from '@slice';
import { GetCampaignResponse, UserNotification } from '@types';
import { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import BaseCampaignNotification from './BaseCampaignNotification';

type PermissionsNotification = { campaignId: string };

export function isValidCampaign(obj: unknown): obj is PermissionsNotification {
  return typeof obj === 'object' && obj !== null && 'campaignId' in obj && typeof (obj as Record<string, unknown>).campaignId === 'string';
}

export interface NavbarMailboxCampaignPermissionsNotificationProps {
  notification: UserNotification;
  onNavigate: (id: string) => void;
}

const NavbarMailboxCampaignPermissionsNotification = ({ notification, onNavigate }: NavbarMailboxCampaignPermissionsNotificationProps) => {
  const dispatch = useDispatch();
  const campaign_id = isValidCampaign(notification.data) ? notification.data.campaignId : null;

  const onNavigated = useCallback(
    (data: GetCampaignResponse | null | undefined) => {
      if (!data) return;
      dispatch(shareCampaign(data));
      onNavigate(notification.id);
    },
    [dispatch, notification.id, onNavigate]
  );

  const renderMessage = useCallback((campaignName: string) => {
    return `New users added to campaign "${campaignName}", you may need to approve their access.`;
  }, []);

  return (
    <BaseCampaignNotification
      notification={notification}
      onNavigate={onNavigate}
      campaignId={campaign_id}
      notificationType="Campaign activity"
      renderMessage={renderMessage}
      actionIcon={<ExpandtoRightOutlined />}
      onAction={onNavigated}
    />
  );
};

export default memo(NavbarMailboxCampaignPermissionsNotification);
